import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const FileDailyIcon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "file-daily",
  "FileDailyIcon",
  ["currentColor"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><path d="M2 0.666687H10.2761L14 4.39054V15.3334H2V0.666687ZM3.33333 2.00002V14H12.6667V4.94283L9.72386 2.00002H3.33333Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/><path d="M4.6665 11.3333H6.00244V12.6693H4.6665V11.3333Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/><path d="M4.6665 8.66663H6.00244V10.0026H4.6665V8.66663Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/><path d="M8.6665 1.33331H9.99984V4.66665H13.3332V5.99998H8.6665V1.33331Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/></g></svg>
);

export default FileDailyIcon;
